import { ApiAccountKey, ApiAccountKeyCreateRequest, ApiAccountKeyCreateResponse } from "src/types/apiAccountKey";

import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { closeDialog } from "@sso/store/slices/dialog";
import { pushSnackbar } from "@sso/store/slices/snackbar";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const apiAccountKeysApi = ssoApi
  .enhanceEndpoints({ addTagTypes: [CacheKeys.API_ACCOUNT_KEYS] })
  .injectEndpoints({
    endpoints: builder => ({
      apiAccountKeys: builder.query<ApiAccountKey[], string>({
        query: apiAccountId => ({ url: `${Endpoints.API_ACCOUNT_KEYS}/Get`, params: { apiAccountId } }),
        providesTags: [CacheKeys.API_ACCOUNT_KEYS],
      }),
      deleteApiAccountKey: builder.mutation<void, string>({
        query: apiAccountKeyId => ({
          url: `${Endpoints.API_ACCOUNT_KEYS}/Delete`,
          method: ApiMethodKeys.DELETE,
          params: { apiAccountKeyId },
        }),
        invalidatesTags: [CacheKeys.API_ACCOUNT_KEYS],
        onQueryStarted(apiAccountKeyId, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.API_ACCOUNT_KEY_DELETE }));
            dispatch(closeDialog());
            dispatch(
              apiAccountKeysApi.util.updateQueryData("apiAccountKeys", apiAccountKeyId, draft => {
                return draft.filter(x => x.apiAccountKeyId != apiAccountKeyId);
              }),
            );
          });
        },
      }),
      createApiAccountKey: builder.mutation<ApiAccountKeyCreateResponse, ApiAccountKeyCreateRequest>({
        query: params => ({ url: `${Endpoints.API_ACCOUNT_KEYS}/Create`, method: ApiMethodKeys.POST, params }),
        invalidatesTags: [CacheKeys.API_ACCOUNT_KEYS],
        onQueryStarted(params, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.API_ACCOUNT_KEY_CREATE }));
          });
        },
      }),
    }),
  });

export const { useApiAccountKeysQuery, useDeleteApiAccountKeyMutation, useCreateApiAccountKeyMutation } =
  apiAccountKeysApi;
